import { Button, Card, CardContent, CardHeader, Stack, Typography } from "@mui/material"
import React from "react"
import { useNavigate } from "react-router"

function VobRepWorklistCard(){
    const navigate = useNavigate();
    return <React.Fragment>
<Card sx={{width:'300px', position:'relative', overflow: 'visible'}}>
    <Button 
        variant='contained' 
        color="primary" 
        sx={{
            position: 'absolute', 
            bottom: '-15px', 
            right: '-15px', 
            backgroundColor:'#62BCBD',
            borderRadius: '20px',
        }} onClick={()=>navigate('/VOBRepWorklist')}>View</Button>
    <CardHeader title="VOB Rep Worklist" sx={{backgroundColor:'#62BCBD', color:'white', height:'40px'}}/>
    <CardContent>
        <Stack direction="row" spacing={2}>
            <Typography variant="body1">Displays the VOB representative worklist for case management.</Typography>
        </Stack>
    </CardContent>
</Card>
    </React.Fragment>
}
export {VobRepWorklistCard}
